// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1mP-T","tab":"Tabs_tab__3a5rA","tabActive":"Tabs_tabActive__19_nT"};